import { createContext, useContext } from 'react';
import { DefaultStorage } from '../../storage';

export const ConsumerTokenStorageContext = createContext<DefaultStorage>(undefined!);

export function useConsumerTokenStorage() {
  return useContext(ConsumerTokenStorageContext);
}
